module.exports = __webpack_public_path__ + "static/media/offers_hover.7b13b7f1.svg";